import React from 'react';
import { useIsMobileOrTablet } from '../../../shared/theme';
import useStore from '../common/funds-state-hook';
import Desktop from './sort-components/desktop';
import Mobile from './sort-components/mobile';

export default function Sorts() {
  const set = useStore(state => state.set);
  const sortOrder = useStore(state => state.sortOrder);
  const [showOptions, setShowOptions] = React.useState(false);
  const Component = useIsMobileOrTablet() ? Mobile : Desktop;

  const toggleShowOptions = e => {
    e && e.preventDefault();

    setShowOptions(!showOptions);
  };

  const setSortOrder = value => {
    if (value !== sortOrder) {
      set(state => {
        state.sortOrder = value;
        state.sortOrderChanged = true;
      });
    }

    setShowOptions(false);
  };

  return (
    <Component
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
      showOptions={showOptions}
      toggleShowOptions={toggleShowOptions}
    />
  );
}
